import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors, FormGroup, FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})

export class DatesValidator {

  constructor() { }

  validate(ds: string, de: string, error: ValidationErrors): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } | null => {

      if (control) {
        // Perform validation between dates
        if (ds && de) {
          let dsControl = control.parent ? control.parent.get(ds) : null
          let deControl = control.parent ? control.parent.get(de) : null
          let dateStart = dsControl ? dsControl.value : null;
          let dateEnd =  deControl ? deControl.value : null;

          let valid = true;

          if (dateStart && dateEnd) {
            let d1 = new Date(dateStart);
            let d2 = new Date(dateEnd);

            valid = (d2.getTime() - d1.getTime()) >= 0;

            if(!valid)
              return {"dates": true};

            // Events cannot have more than one year as duration.
            valid = (((d2.getTime()-d1.getTime())/(1000*60*60*24*365)) <= 1);

            if(!valid)
              return {"dates-duration":true};

          }

          if(dsControl && dsControl.errors)
            delete dsControl.errors['dates']

          if(deControl && deControl.errors)
            delete deControl.errors['dates']

        }else{
          if(ds){
            let dateStart = control.parent && control.parent.get(ds) ? control.parent.get(ds).value : null;

            let d1 = new Date(dateStart);

            // If is not able to parse date, returns invalid-date error
            if(d1.toString() == "Invalid Date"){
              return {"invalid-date":true};
            }

            if(d1.getTime() < Date.now()){
              return error;
            }
          }

          if(de){
            let dateEnd = control.parent && control.parent.get(de) ? control.parent.get(de).value : null;

            let d2 = new Date(dateEnd);

            // If is not able to parse date, returns invalid-date error
            if(d2.toString() == "Invalid Date"){
              return {"invalid-date":true};
            }

            if(d2.getTime() < Date.now()){
              return error;
            }
          }
        }
      }

      return null;

    };
  }
}
